import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, PanResponder, StyleSheet, TouchableHighlight, Animated, ViewPropTypes } from 'react-native';
import Colors from '../constants/Colors';

// modernized version of
// https://github.com/recr0ns/react-native-material-switch/blob/master/index.js

class MaterialSwitch extends Component {
  static propTypes = {
    active: PropTypes.bool,
    style: PropTypes.any,
    inactiveButtonColor: PropTypes.string,
    inactiveButtonPressedColor: PropTypes.string,
    activeButtonColor: PropTypes.string,
    activeButtonPressedColor: PropTypes.string,
    buttonShadow: PropTypes.any,
    activeBackgroundColor: PropTypes.string,
    inactiveBackgroundColor: PropTypes.string,
    buttonRadius: PropTypes.number,
    switchWidth: PropTypes.number,
    switchHeight: PropTypes.number,
    buttonContent: PropTypes.element,
    enableSlide: PropTypes.bool,
    enableSlideDragging: PropTypes.bool,
    switchAnimationTime: PropTypes.number,
    onActivate: PropTypes.func,
    onDeactivate: PropTypes.func,
    onChangeState: PropTypes.func,
    testID: PropTypes.string,
  };

  static defaultProps = {
    active: false,
    style: {},
    activeButtonColor: Colors.primaryColor,
    activeButtonPressedColor: Colors.primaryColor,
    inactiveButtonColor: '#FAFAFA',
    inactiveButtonPressedColor: '#F5F5F5',
    buttonShadow: {
      elevation: 3,
      shadowColor: '#000',
      shadowOpacity: 0.5,
      shadowRadius: 1,
      shadowOffset: { height: 1, width: 0 },
    },
    activeBackgroundColor: '#81B9B1',
    inactiveBackgroundColor: 'rgba(0,0,0,.25)',
    buttonRadius: 10,
    switchWidth: 34,
    switchHeight: 14,
    buttonContent: null,
    buttonOffset: 0,
    enableSlide: true,
    enableSlideDragging: true,
    switchAnimationTime: 200,
    onActivate: function () {},
    onDeactivate: function () {},
    onChangeState: function () {},
    testID: 'material-switch',
  };

  constructor(props) {
    super();

    var w = props.switchWidth - Math.min(props.switchHeight, props.buttonRadius * 2) - props.buttonOffset;

    this.state = {
      width: w,
      state: props.active,
      position: new Animated.Value(props.active ? w : props.buttonOffset),
    };
  }

  padding = 8;

  start = {};

  UNSAFE_componentWillMount = () => {
    this._panResponder = PanResponder.create({
      onStartShouldSetPanResponder: (evt, gestureState) => true,
      onStartShouldSetPanResponderCapture: (evt, gestureState) => true,
      onMoveShouldSetPanResponder: (evt, gestureState) => true,
      onMoveShouldSetPanResponderCapture: (evt, gestureState) => true,

      onPanResponderGrant: (evt, gestureState) => {
        if (!this.props.enableSlide) return;

        this.setState({ pressed: true });
        this.start.x0 = gestureState.x0;
        this.start.pos = this.state.position._value;
        this.start.moved = false;
        this.start.state = this.state.state;
        this.start.stateChanged = false;
      },
      onPanResponderMove: (evt, gestureState) => {
        if (!this.props.enableSlide) return;

        this.start.moved = true;
        if (this.start.pos == 0) {
          if (gestureState.dx <= this.state.width && gestureState.dx >= 0) {
            this.state.position.setValue(gestureState.dx);
          }
          if (gestureState.dx > this.state.width) {
            this.state.position.setValue(this.state.width);
          }
          if (gestureState.dx < 0) {
            this.state.position.setValue(0);
          }
        }
        if (this.start.pos == this.state.width) {
          if (gestureState.dx >= -this.state.width && gestureState.dx <= 0) {
            this.state.position.setValue(this.state.width + gestureState.dx);
          }
          if (gestureState.dx > 0) {
            this.state.position.setValue(this.state.width);
          }
          if (gestureState.dx < -this.state.width) {
            this.state.position.setValue(0);
          }
        }
        var currentPos = this.state.position._value;
        this.onSwipe(
          currentPos,
          this.start.pos,
          () => {
            if (!this.start.state) this.start.stateChanged = true;
            this.setState({ state: true });
          },
          () => {
            if (this.start.state) this.start.stateChanged = true;
            this.setState({ state: false });
          }
        );
      },
      onPanResponderTerminationRequest: (evt, gestureState) => true,
      onPanResponderRelease: (evt, gestureState) => {
        this.setState({ pressed: false });
        var currentPos = this.state.position._value;
        if (!this.start.moved || (Math.abs(currentPos - this.start.pos) < 5 && !this.start.stateChanged)) {
          this.toggle();
          return;
        }
        this.onSwipe(currentPos, this.start.pos, this.activate, this.deactivate);
      },
      onPanResponderTerminate: (evt, gestureState) => {
        var currentPos = this.state.position._value;
        this.setState({ pressed: false });
        this.onSwipe(currentPos, this.start.pos, this.activate, this.deactivate);
      },
      onShouldBlockNativeResponder: (evt, gestureState) => true,
    });
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (this.state.state !== nextProps.active) {
      nextProps.active ? this.activate() : this.deactivate();
    }
  };

  onSwipe = (currentPosition, startingPosition, onChange, onTerminate) => {
    if (currentPosition - startingPosition >= 0) {
      if (currentPosition - startingPosition > this.state.width / 2 || startingPosition == this.state.width) {
        onChange();
      } else {
        onTerminate();
      }
    } else {
      if (currentPosition - startingPosition < -this.state.width / 2) {
        onTerminate();
      } else {
        onChange();
      }
    }
  };

  activate = () => {
    Animated.timing(this.state.position, {
      toValue: this.state.width,
      duration: this.props.switchAnimationTime,
      useNativeDriver: true,
    }).start();
    this.changeState(true);
  };

  deactivate = () => {
    Animated.timing(this.state.position, {
      toValue: this.props.buttonOffset,
      duration: this.props.switchAnimationTime,
      useNativeDriver: true,
    }).start();
    this.changeState(false);
  };

  changeState = (state) => {
    var callHandlers = this.start.state != state;

    setTimeout(() => {
      this.setState({ state: state }, () => {
        if (callHandlers) {
          this.callback();
        }
      });
    }, this.props.switchAnimationTime / 2);
  };

  callback = () => {
    var state = this.state.state;
    if (state) {
      this.props.onActivate();
    } else {
      this.props.onDeactivate();
    }
    this.props.onChangeState(state);
  };

  toggle = () => {
    if (!this.props.enableSlide) return;

    if (this.state.state) {
      this.deactivate();
    } else {
      this.activate();
    }
  };

  render() {
    const {
      enableSlideDragging,
      style,
      activeBackgroundColor,
      inactiveBackgroundColor,
      switchHeight,
      switchWidth,
      buttonRadius,
      activeButtonPressedColor,
      activeButtonColor,
      inactiveButtonPressedColor,
      inactiveButtonColor,
      buttonShadow,
      buttonContent,
      testID,
    } = this.props;
    const { state, pressed, position } = this.state;
    var doublePadding = this.padding * 2 - 2;
    var halfPadding = doublePadding / 2;

    let panHandlers = enableSlideDragging ? this._panResponder.panHandlers : null;
    let pressHandlers = !enableSlideDragging ? { onPress: () => this.toggle() } : null;

    return (
      <View
        {...panHandlers}
        style={[{ padding: this.padding, position: 'relative' }, style]}
        testID={testID || ''}
      >
        <View
          style={{
            backgroundColor: state ? activeBackgroundColor : inactiveBackgroundColor,
            height: switchHeight,
            width: switchWidth,
            borderRadius: switchHeight / 2,
          }}
        />
        <TouchableHighlight
          {...pressHandlers}
          underlayColor="transparent"
          activeOpacity={1}
          style={{
            height: Math.max(buttonRadius * 2 + doublePadding, switchHeight + doublePadding),
            width: switchWidth + doublePadding,
            position: 'absolute',
            top: 1,
            left: 1,
          }}
        >
          <Animated.View
            style={[
              {
                backgroundColor: state
                  ? pressed
                    ? activeButtonPressedColor
                    : activeButtonColor
                  : pressed
                  ? inactiveButtonPressedColor
                  : inactiveButtonColor,
                height: buttonRadius * 2,
                width: buttonRadius * 2,
                borderRadius: buttonRadius,
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
                position: 'absolute',
                top: halfPadding + switchHeight / 2 - buttonRadius,
                left:
                  switchHeight / 2 > buttonRadius
                    ? halfPadding
                    : halfPadding + switchHeight / 2 - buttonRadius,
                transform: [{ translateX: position }],
              },
              buttonShadow,
            ]}
          >
            {buttonContent}
          </Animated.View>
        </TouchableHighlight>
      </View>
    );
  }
}

export default MaterialSwitch;
